import { usePortalOverview } from './usePortalOverview';
import { formatDay } from './portalUtils';
import './portal.css';

export function WorkoutView() {
  const { data, isLoading, isError } = usePortalOverview();
  if (isLoading) return <div className="portal-page"><div className="portal-spinner">Loading…</div></div>;
  if (isError || !data) return <div className="portal-page"><div className="portal-error">Unable to load your workout.</div></div>;

  const adjustments = data.adjustments ?? [];

  return (
    <div className="portal-page portal-workout">
      <div className="portal-page-header"><h1>My workout</h1></div>
      <div className="portal-workout-grid">
        <div className="portal-section">
          <h2>Program</h2>
          {data.program
            ? <p className="portal-body-text portal-pre">{data.program}</p>
            : <p className="portal-muted">Your trainer hasn’t set a program yet.</p>}
        </div>

        <aside className="portal-section portal-adjustments">
          <h2>Adjustments</h2>
          {adjustments.length === 0 ? (
            <p className="portal-muted">No adjustments logged yet.</p>
          ) : (
            adjustments.map((adj, i) => (
              <div key={i} className="portal-adj-row">
                <div className="portal-adj-date">{formatDay(adj.date)}</div>
                <div className="portal-adj-note">{adj.note}</div>
              </div>
            ))
          )}
        </aside>
      </div>
    </div>
  );
}
